(() => {
  const gallerySelector =
    '.product--thumbnail_slider .product__media-wrapper > media-gallery';
  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

  const getViewer = (gallery) =>
    gallery.querySelector('slider-component[id^="GalleryViewer"]');

  const getMediaItems = (viewer) =>
    Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));

  function syncControls(gallery) {
    const viewer = getViewer(gallery);
    if (!viewer) return;

    const mediaItems = getMediaItems(viewer);
    const activeIndex = Math.max(
      0,
      mediaItems.findIndex((item) => item.classList.contains('is-active'))
    );

    viewer
      .querySelectorAll('.slider-buttons')
      .forEach((controls) => {
        controls.hidden = mediaItems.length < 2;

        const previous = controls.querySelector('.slider-button--prev');
        const next = controls.querySelector('.slider-button--next');

        if (previous) {
          previous.disabled = activeIndex === 0;
          previous.setAttribute('aria-disabled', String(activeIndex === 0));
        }

        if (next) {
          next.disabled = activeIndex === mediaItems.length - 1;
          next.setAttribute(
            'aria-disabled',
            String(activeIndex === mediaItems.length - 1)
          );
        }
      });

    viewer.querySelectorAll('.slider-counter--current').forEach((counter) => {
      counter.textContent = String(activeIndex + 1);
    });
  }

  function initialiseGallery(gallery) {
    if (gallery.dataset.libaasGalleryControlsInitialised === 'true') return;

    const viewer = getViewer(gallery);
    if (!viewer || typeof gallery.setActiveMedia !== 'function') return;

    gallery.dataset.libaasGalleryControlsInitialised = 'true';

    gallery.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest(
          '[id^="GalleryViewer"] > .slider-buttons > .slider-button[name]'
        );

        if (!button || !gallery.contains(button) || !desktopMediaQuery.matches) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const mediaItems = getMediaItems(viewer);
        const activeIndex = Math.max(
          0,
          mediaItems.findIndex((item) => item.classList.contains('is-active'))
        );
        const offset = button.name === 'next' ? 1 : -1;
        const targetIndex = Math.max(
          0,
          Math.min(mediaItems.length - 1, activeIndex + offset)
        );

        if (targetIndex !== activeIndex) {
          gallery.setActiveMedia(mediaItems[targetIndex].dataset.mediaId, false);
        }

        syncControls(gallery);
      },
      true
    );

    const observer = new MutationObserver(() => syncControls(gallery));
    observer.observe(viewer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    desktopMediaQuery.addEventListener('change', () => syncControls(gallery));
    syncControls(gallery);
  }

  function initialise(root = document) {
    root.querySelectorAll(gallerySelector).forEach(initialiseGallery);
  }

  function ready() {
    customElements.whenDefined('media-gallery').then(() => {
      initialise();
      document.addEventListener('shopify:section:load', (event) => {
        initialise(event.target);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
